import styled from "styled-components";
import { Link } from "react-router-dom";

export const HeaderFriendsPillContainer = styled(Link)`
    text-decoration: none;
    color: inherit;

    .MuiSvgIcon-root {
        color: #FFFFFF;
        font-size: 20px;

        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
    }
`;
